import Vue from 'vue';
import PageContent from './_components/AvailabilityPage';

(function() {
    new Vue({
        el: 'main > #vueable',

        components: {
            PageContent,
        },

        template: '<PageContent :snippets="snippets" :stripe-key="stripeKey" />',

        data() {
            return {
                snippets: snippets,
                stripeKey: stripeKey,
            }
        }
    });
})();
